import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';

const ValidateForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="validateFormAction"
        label="action"
        name="action"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        required
        error={errors?.action?.message}
        defaultValue="VALIDATE"
      />

      <FormField
        controlId="validateFormCommand"
        label="command"
        name="command"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        error={errors?.command?.message}
        defaultValue="VALIDATE"
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default ValidateForm;
